import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEmphasis12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveEmphasis12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.189 1.657a.45.45 0 0 1-.45.45H2.268a.45.45 0 0 1 0-.9h7.471a.45.45 0 0 1 .45.45m0 8.678a.45.45 0 0 1-.45.45H2.268a.45.45 0 0 1 0-.9h7.471a.45.45 0 0 1 .45.45M8.773 5.996a2.776 2.776 0 1 1-5.552-.001 2.776 2.776 0 0 1 5.552.001m-.9 0a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0"
            />
        </svg>
    );
}
export default memo(IconMoveEmphasis12);
